import type { Transport } from '../types';
import { extractText, postChat } from './http';

/**
 * Plain request/response. The whole reply arrives at once.
 * Use `config.parseResponse` when the reply lives somewhere `extractText`
 * cannot guess, e.g. `(data) => data.result.blocks[0].value`.
 */
export const jsonTransport: Transport = async function* (req) {
  const response = await postChat(req, false);
  const contentType = response.headers.get('content-type') ?? '';

  let data: unknown;
  if (contentType.includes('application/json')) {
    data = await response.json();
  } else {
    data = await response.text();
  }

  const parse = req.config.parseResponse ?? extractText;
  const text = parse(data);

  if (data && typeof data === 'object') {
    const { conversationId, messageId, meta, sources } = data as Record<string, unknown>;
    const extras: Record<string, unknown> = {};
    if (conversationId !== undefined) extras.conversationId = conversationId;
    if (messageId !== undefined) extras.messageId = messageId;
    if (meta !== undefined) extras.meta = meta;
    if (sources !== undefined) extras.sources = sources;
    if (Object.keys(extras).length) yield { type: 'meta', data: extras };
  }

  if (!text) {
    yield {
      type: 'error',
      error: 'The server replied with an empty message. Provide config.parseResponse if the reply is nested.',
    };
    return;
  }

  yield { type: 'message', text };
};
